import { cn } from '../../lib/cn'

export interface SpinnerProps {
  className?: string
  size?: 'xs' | 'sm' | 'md' | 'lg'
}

export function Spinner({ className, size }: SpinnerProps) {
  const hasCustomSize = Boolean(size || (className && /\b[hw]-/.test(className)))
  const sizeClass = size
    ? {
        xs: 'h-2.5 w-2.5 border-[1px]',
        sm: 'h-3 w-3 border-[1.5px]',
        md: 'h-5 w-5 border-2',
        lg: 'h-6 w-6 border-2',
      }[size]
    : hasCustomSize
      ? ''
      : 'h-5 w-5 border-2'

  return (
    <span
      role="status"
      aria-label="loading"
      className={cn('inline-block shrink-0 animate-spin rounded-full border-current border-t-transparent', sizeClass, className)}
    />
  )
}
